export const GET_AVAILABLE_APPOINTMENT = 'GET_AVAILABLE_APPOINTMENT'
export const GET_ALL_APPOINTMENTS_AUCTION = 'GET_ALL_APPOINTMENTS_AUCTION'
export const GET_ALL_APPOINTMENTS_USER = 'GET_ALL_APPOINTMENTS_USER'
export const GET_INVOICE_APPOINTMENT = 'GET_INVOICE_APPOINTMENT'
export const GET_APPOINTMENT_DETAIL_USER = 'GET_APPOINTMENT_DETAIL_USER'

export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
